import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ProblematicFtdTable, {
  PROBLEMATIC_FTD_COLUMNS,
} from "./ProblematicFtdTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const ProblematicFtd = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const problematicFtdData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.problematicFtdData,
  );

  const problematicFtdMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.problematicFtdMetadata,
  );

  const isFetchedForFtdData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForFtdData,
  );

  //-- Extract unique brand names for the search filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (problematicFtdData || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [problematicFtdData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return problematicFtdData;
    return (problematicFtdData || []).filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [problematicFtdData, choosenBrand]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Problematic FTDs in the Last 60 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="876"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="874"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                PROBLEMATIC_FTD_COLUMNS,
                "problematic-ftd.csv",
              )
            }
            disabled={
              (problematicFtdData?.length ?? 0) === 0 || !isFetchedForFtdData
            }
          />
        </Grid>
      </Grid>
      <ProblematicFtdTable
        metadata={problematicFtdMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default ProblematicFtd;
